<template>
  <article class="the-magazine" :class="isFeaturedCard ? 'featured-card' : ''" role="article" itemscope itemtype="http://schema.org/Article">
    <figure class="the-magazine__card">
      <div class="the-magazine__card--img">
        <a :href="`${cardData.link}`" rel="bookmark" title="Go to latest issue">
          <picture>
            <!-- Mobile image -->
            <source media="(max-width: 767px)" :srcset="cardData.mobileImg">
            <!-- Desktop image -->
            <img :src="cardData.desktopImg" alt="Fabric Magazine - latest issue" width="580" height="818" loading="lazy" itemprop="image"/>
          </picture>
        </a>
      </div>
      <figcaption class="the-magazine__card--content" itemprop="description">
        <div class="the-magazine__card--header">
          <span v-if="isFeaturedCard" class="card-cat" itemprop="articleSection">Latest issue </span>
          <time class="card-date" itemprop="datePublished"> <span v-if="isFeaturedCard">/</span> {{ cardData.pageName }}</time>
        </div>
        <h3 itemprop="headline">{{ cardData.magazineName }}</h3>
        <a class="" :href="`${cardData.link}`" itemprop="url">
          Read Online
        </a>
      </figcaption>
    </figure>
  </article>
</template>

<script>
import('Assets/scss/components/vue/cards/article-card.scss');

export default {
  name: "TheMagazineCard",
  props: {
    cardData: {
      type: Object,
      required: true,
    },
    isFeaturedCard: {
      type: Boolean,
      default: false
    },
  }
};
</script>